import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SearchIcon, FilterIcon, GridIcon, ListIcon, MapIcon, ShipIcon, HomeIcon, GlobeIcon, UsersIcon, UserIcon, LayoutIcon, ChevronRightIcon } from 'lucide-react';
import { ProductCard } from './ProductCard';
import { ComparisonBar } from './ComparisonBar';
import { SectorOverview } from './SectorOverview';
// Mock product data
const products = [{
  id: 1,
  title: 'Japan Cultural Explorer',
  destination: 'Japan',
  duration: '10 days',
  price: 2899,
  image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'git',
  rating: 4.8,
  featured: true,
  departures: 12,
  sector: 'Asia'
}, {
  id: 2,
  title: 'Italian Renaissance Journey',
  destination: 'Italy',
  duration: '12 days',
  price: 3299,
  image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'git',
  rating: 4.7,
  featured: false,
  departures: 8,
  sector: 'Europe'
}, {
  id: 3,
  title: 'Bali Paradise Retreat',
  destination: 'Indonesia',
  duration: '7 days',
  price: 1899,
  image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'fit',
  rating: 4.9,
  featured: true,
  departures: 24,
  sector: 'Asia'
}, {
  id: 4,
  title: 'Greek Islands Cruise',
  destination: 'Greece',
  duration: '8 days',
  price: 2499,
  image: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'cruises',
  rating: 4.6,
  featured: false,
  departures: 6,
  sector: 'Europe'
}, {
  id: 5,
  title: 'Luxury Paris Getaway',
  destination: 'France',
  duration: '5 days',
  price: 2199,
  image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'fit',
  rating: 4.8,
  featured: false,
  departures: 15,
  sector: 'Europe'
}, {
  id: 6,
  title: 'Caribbean Cruise Deluxe',
  destination: 'Caribbean',
  duration: '7 days',
  price: 1999,
  image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'cruises',
  rating: 4.5,
  featured: true,
  departures: 10,
  sector: 'Americas'
}, {
  id: 7,
  title: 'Swiss Alps Adventure',
  destination: 'Switzerland',
  duration: '8 days',
  price: 2799,
  image: 'https://images.unsplash.com/photo-1491555103944-7c647fd857e6?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'git',
  rating: 4.9,
  featured: false,
  departures: 6,
  sector: 'Europe'
}, {
  id: 8,
  title: 'Maldives Luxury Resort',
  destination: 'Maldives',
  duration: '6 days',
  price: 3499,
  image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'hotels',
  rating: 5.0,
  featured: true,
  departures: 30,
  sector: 'Asia'
}, {
  id: 9,
  title: 'Beijing & Great Wall Explorer',
  destination: 'China',
  duration: '9 days',
  price: 2399,
  image: 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'git',
  rating: 4.7,
  featured: false,
  departures: 14,
  sector: 'China'
}, {
  id: 10,
  title: 'Peru & Machu Picchu Adventure',
  destination: 'Peru',
  duration: '10 days',
  price: 2799,
  image: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'git',
  rating: 4.9,
  featured: true,
  departures: 8,
  sector: 'Americas'
}, {
  id: 11,
  title: 'Morocco Desert Safari',
  destination: 'Morocco',
  duration: '8 days',
  price: 1899,
  image: 'https://images.unsplash.com/photo-1489493585363-d69421e0edd3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'git',
  rating: 4.8,
  featured: false,
  departures: 12,
  sector: 'Africa & Middle East'
}, {
  id: 12,
  title: 'Shanghai to Hong Kong Journey',
  destination: 'China',
  duration: '11 days',
  price: 2599,
  image: 'https://images.unsplash.com/photo-1474181487882-5abf3f0ba6c2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  category: 'git',
  rating: 4.6,
  featured: false,
  departures: 10,
  sector: 'China'
}];
// Define sectors with images
const sectors = [{
  id: 'Asia',
  name: 'Asia',
  image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  description: 'Explore ancient temples, vibrant cities, and stunning landscapes across Asia.'
}, {
  id: 'Europe',
  name: 'Europe',
  image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  description: 'Discover historical landmarks, rich cultures, and picturesque villages throughout Europe.'
}, {
  id: 'China',
  name: 'China',
  image: 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  description: 'Experience the wonders of ancient and modern China, from the Great Wall to bustling metropolises.'
}, {
  id: 'Americas',
  name: 'Americas',
  image: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  description: 'Journey through diverse landscapes and vibrant cultures of North and South America.'
}, {
  id: 'Africa & Middle East',
  name: 'Africa & Middle East',
  image: 'https://images.unsplash.com/photo-1489493585363-d69421e0edd3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  description: 'Venture into ancient civilizations, vast deserts, and wildlife safaris across Africa and the Middle East.'
}];
export const ProductCatalog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [viewMode, setViewMode] = useState('grid');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedSector, setSelectedSector] = useState('');
  const [showSectors, setShowSectors] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [comparisonList, setComparisonList] = useState<number[]>([]);
  // Set up sectors view when GIT is selected
  useEffect(() => {
    if (selectedCategory === 'git' && !selectedSector) {
      setShowSectors(true);
    } else {
      setShowSectors(false);
    }
  }, [selectedCategory, selectedSector]);
  const categories = [{
    id: 'all',
    name: 'All Products',
    icon: <GlobeIcon className="h-4 w-4" data-id="element-2913" />
  }, {
    id: 'git',
    name: 'Group Tours (GIT)',
    icon: <UsersIcon className="h-4 w-4" data-id="element-2914" />
  }, {
    id: 'fit',
    name: 'Custom Tours (FIT)',
    icon: <UserIcon className="h-4 w-4" data-id="element-2915" />
  }, {
    id: 'cruises',
    name: 'Cruises',
    icon: <ShipIcon className="h-4 w-4" data-id="element-2916" />
  }, {
    id: 'hotels',
    name: 'Hotels',
    icon: <HomeIcon className="h-4 w-4" data-id="element-2917" />
  }, {
    id: 'destinations',
    name: 'Destinations',
    icon: <MapIcon className="h-4 w-4" data-id="element-2918" />
  }];
  // Filter products based on selected category and sector
  const filteredProducts = products.filter(product => {
    // Filter by category
    if (selectedCategory !== 'all' && product.category !== selectedCategory) {
      return false;
    }
    // Filter by sector if one is selected
    if (selectedSector && product.sector !== selectedSector) {
      return false;
    }
    // Filter by search term
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      return product.title.toLowerCase().includes(term) || product.destination.toLowerCase().includes(term);
    }
    return true;
  });
  // Calculate sector statistics
  const sectorStats = sectors.map(sector => {
    const sectorProducts = products.filter(p => p.category === 'git' && p.sector === sector.id);
    const tourCount = sectorProducts.length;
    const minPrice = Math.min(...sectorProducts.map(p => p.price));
    const maxPrice = Math.max(...sectorProducts.map(p => p.price));
    return {
      ...sector,
      tourCount,
      priceRange: tourCount ? `$${minPrice} - $${maxPrice}` : 'N/A'
    };
  });
  const handleProductSelect = (productId: number) => {
    navigate(`/products/${productId}`);
  };
  const handleSectorSelect = (sectorId: string) => {
    setSelectedSector(sectorId);
  };
  const handleCompareClick = (e: React.MouseEvent, productId: number) => {
    e.stopPropagation();
    if (comparisonList.includes(productId)) {
      setComparisonList(comparisonList.filter(id => id !== productId));
    } else if (comparisonList.length < 3) {
      setComparisonList([...comparisonList, productId]);
    }
  };
  const clearComparison = () => {
    setComparisonList([]);
  };
  const removeFromComparison = (productId: number) => {
    setComparisonList(comparisonList.filter(id => id !== productId));
  };
  const selectedProductsData = products.filter(product => comparisonList.includes(product.id));
  const resetSectorFilter = () => {
    setSelectedSector('');
  };
  return <div className="space-y-6" data-id="element-2919">
      <div className="flex justify-between items-center" data-id="element-2920">
        <div data-id="element-2921">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-2922">Products</h1>
          {/* Breadcrumb navigation */}
          {selectedCategory === 'git' && <div className="flex items-center text-sm text-gray-500 mt-1" data-id="element-2923">
              <span data-id="element-2924">Products</span>
              <ChevronRightIcon className="h-4 w-4 mx-1" data-id="element-2925" />
              <span data-id="element-2926">Group Tours</span>
              {selectedSector && <>
                  <ChevronRightIcon className="h-4 w-4 mx-1" data-id="element-2927" />
                  <span className="text-blue-600" data-id="element-2928">{selectedSector}</span>
                </>}
            </div>}
        </div>
        <div className="flex space-x-2" data-id="element-2929">
          <button className={`p-2 rounded-md ${viewMode === 'grid' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`} onClick={() => setViewMode('grid')} data-id="element-2930">
            <GridIcon className="h-5 w-5" data-id="element-2931" />
          </button>
          <button className={`p-2 rounded-md ${viewMode === 'list' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`} onClick={() => setViewMode('list')} data-id="element-2932">
            <ListIcon className="h-5 w-5" data-id="element-2933" />
          </button>
          <div className="relative" data-id="element-2934">
            <input type="text" placeholder="Search products..." className="pl-9 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-2935" />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2936">
              <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-2937" />
            </div>
          </div>
          <button className="p-2 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-2938">
            <FilterIcon className="h-5 w-5" data-id="element-2939" />
          </button>
          <button className="px-4 py-2 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 flex items-center" onClick={() => navigate('/compare')} data-id="element-2940">
            <LayoutIcon className="h-4 w-4 mr-2" data-id="element-2941" />
            Add to Compare ({comparisonList.length})
          </button>
        </div>
      </div>

      {/* Category Tabs */}
      <div className="flex overflow-x-auto pb-2 space-x-2" data-id="element-2942">
        {categories.map(category => <button key={category.id} className={`flex items-center px-4 py-2 rounded-full whitespace-nowrap ${selectedCategory === category.id ? 'bg-blue-600 text-white' : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'}`} onClick={() => {
        setSelectedCategory(category.id);
        setSelectedSector('');
      }} data-id="element-2943">
            <span className="mr-2" data-id="element-2944">{category.icon}</span>
            {category.name}
          </button>)}
      </div>

      {/* Sector Selection (only for GIT) */}
      {showSectors ? <SectorOverview sectors={sectorStats} onSectorSelect={handleSectorSelect} data-id="element-2945" /> : <>
          {/* Back to Sectors button when a sector is selected */}
          {selectedCategory === 'git' && selectedSector && <button className="mb-4 flex items-center text-blue-600 hover:text-blue-800" onClick={resetSectorFilter} data-id="element-2946">
              <ChevronRightIcon className="h-4 w-4 mr-1 transform rotate-180" data-id="element-2947" />
              Back to All Sectors
            </button>}

          {/* Featured Products Banner (only shown when viewing all products) */}
          {selectedCategory === 'all' && <div className="relative h-48 bg-gradient-to-r from-blue-500 to-teal-400 rounded-lg overflow-hidden mb-6" data-id="element-2948">
              <div className="absolute inset-0 bg-black bg-opacity-20" data-id="element-2949"></div>
              <div className="absolute inset-0 flex items-center" data-id="element-2950">
                <div className="pl-8 pr-4 py-6 max-w-lg" data-id="element-2951">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-2952">
                    Featured Products
                  </h3>
                  <p className="text-white text-opacity-90 mb-4" data-id="element-2953">
                    Explore our handpicked selection of premium travel
                    experiences
                  </p>
                  <button className="px-4 py-2 bg-white text-blue-600 rounded-md font-medium hover:bg-blue-50" data-id="element-2954">
                    View Featured
                  </button>
                </div>
              </div>
              <img src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Featured Products" className="absolute top-0 right-0 h-full w-1/2 object-cover object-left" data-id="element-2955" />
            </div>}

          {/* Products Grid */}
          <div className={`grid ${viewMode === 'grid' ? 'grid-cols-4' : 'grid-cols-1'} gap-6`} data-id="element-2956">
            {filteredProducts.map(product => <ProductCard key={product.id} product={product} viewMode={viewMode} onClick={() => handleProductSelect(product.id)} onCompareClick={handleCompareClick} isInComparison={comparisonList.includes(product.id)} data-id="element-2957" />)}
          </div>

          {filteredProducts.length === 0 && <div className="flex flex-col items-center justify-center h-64 bg-white rounded-lg shadow-md" data-id="element-2958">
              <p className="text-lg text-gray-500 mb-4" data-id="element-2959">
                No products match your criteria
              </p>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" onClick={() => {
          setSelectedCategory('all');
          setSelectedSector('');
          setSearchTerm('');
        }} data-id="element-2960">
                Reset Filters
              </button>
            </div>}
        </>}

      {/* Comparison Bar */}
      <ComparisonBar selectedProducts={selectedProductsData} removeFromComparison={removeFromComparison} clearComparison={clearComparison} data-id="element-2961" />
    </div>;
};